import { render, staticRenderFns } from "./SetWeek.vue?vue&type=template&id=3058981e&"
import script from "./SetWeek.vue?vue&type=script&lang=js&"
export * from "./SetWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports